export const VIDEO_BUFFER = 5;
export const YOUTUBE_VIDEO_BUFFER = 10;
